import { SELECTION_A, SELECTION_B } from 'common/constants/valuations';
import { PERCENTILE_SELECTION_A, PERCENTILE_SELECTION_B } from './constants';

export const mapPercentileAliasToDatabaseValue = alias =>
  alias === PERCENTILE_SELECTION_A ? SELECTION_A : SELECTION_B;

export const isPercentileAlias = alias => [PERCENTILE_SELECTION_A, PERCENTILE_SELECTION_B].includes(alias);
